import { authTokenManager } from "gather-auth-client/dist/src/public/auth";
import { API_BASE_PATH } from "../basePaths";
import { getSpaceIdFromPath } from "../utils";
import WebWorkerClient from "../worker/WebWorkerClient";
import HttpV2Client from "gather-http-v2-client/dist/src/public/httpV2Client";
import { switchEnv } from "gather-env-config/dist/src/public/env";
export const DEFAULT_PATH_PARAMS = {
    space: () => getSpaceIdFromPath() || "",
};
export const WebWorkerClientWrapper = {
    get: (finalPath, axiosConfig) => WebWorkerClient.get(finalPath, axiosConfig),
    post: (finalPath, body, axiosConfig) => WebWorkerClient.post(finalPath, body, axiosConfig),
    patch: (finalPath, body, axiosConfig) => WebWorkerClient.patch(finalPath, body, axiosConfig),
    put: (finalPath, body, axiosConfig) => WebWorkerClient.put(finalPath, body, axiosConfig),
    delete: (finalPath, axiosConfig) => WebWorkerClient.delete(finalPath, axiosConfig),
};
const HttpV2ClientBrowser = new HttpV2Client({
    apiBasePath: API_BASE_PATH,
    authManager: authTokenManager,
    defaultPathParams: DEFAULT_PATH_PARAMS,
    webWorkerClient: WebWorkerClientWrapper,
    customHeaders: switchEnv({
        prod: () => ({}),
        staging: () => ({}),
        dev: () => ({}),
        local: () => API_BASE_PATH.includes(".ngrok-free.app") ? { "ngrok-skip-browser-warning": true } : {},
        test: () => ({}),
    }),
});
export default HttpV2ClientBrowser;
//# sourceMappingURL=httpV2Client.js.map